"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.DND_FILE_LIST_ITEM_TYPE = void 0;

var _react = require("@chakra-ui/react");

var _reactDnd = require("react-dnd");

var _jsxRuntime = require("react/jsx-runtime");

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

var DND_FILE_LIST_ITEM_TYPE = 'row';
exports.DND_FILE_LIST_ITEM_TYPE = DND_FILE_LIST_ITEM_TYPE;

var TableRow = function TableRow(props) {
  var blueBgColor = (0, _react.useColorModeValue)('blue.100', 'blue.400');

  var _useDrop = (0, _reactDnd.useDrop)({
    accept: DND_FILE_LIST_ITEM_TYPE,
    drop: function drop(item, monitor) {
      //monitor.isOver({shallow: false})
      props.onDnD(item.index, props.index);
    }
  }),
      _useDrop2 = _slicedToArray(_useDrop, 2),
      drop = _useDrop2[1];

  var _useDrag = (0, _reactDnd.useDrag)({
    type: DND_FILE_LIST_ITEM_TYPE,
    item: {
      type: DND_FILE_LIST_ITEM_TYPE,
      index: props.index
    },
    collect: function collect(monitor) {
      return {
        isDragging: monitor.isDragging()
      };
    }
  }),
      _useDrag2 = _slicedToArray(_useDrag, 2),
      isDragging = _useDrag2[0].isDragging,
      drag = _useDrag2[1];

  var opacity = isDragging ? 0 : 1;

  var dndRefs = function dndRefs(el) {
    drag(el);
    drop(el);
  };

  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Tr, {
    ref: dndRefs,
    style: {
      opacity: opacity
    },
    fontSize: "sm",
    bg: props.isSelected ? blueBgColor : undefined,
    onClick: function onClick(e) {
      return props.onClick(e, props.index);
    },
    onDoubleClick: function onDoubleClick(e) {
      return props.onDoubleClick(e, props.index);
    },
    onContextMenu: function onContextMenu(e) {
      return props.onContextMenu(e, props.index);
    },
    children: props.row.cells.map(function (cell) {
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(_react.Td, _objectSpread(_objectSpread({}, cell.getCellProps()), {}, {
        isNumeric: cell.column.isNumeric,
        children: cell.render('Cell')
      }));
    })
  });
};

var _default = TableRow;
exports["default"] = _default;